module.exports = __webpack_public_path__ + "static/media/backIcon.2597ef41.svg";